import { render, staticRenderFns } from "./imgY.vue?vue&type=template&id=783d4df2&scoped=true"
var script = {}
import style0 from "./imgY.vue?vue&type=style&index=0&id=783d4df2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d4df2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('783d4df2')) {
      api.createRecord('783d4df2', component.options)
    } else {
      api.reload('783d4df2', component.options)
    }
    module.hot.accept("./imgY.vue?vue&type=template&id=783d4df2&scoped=true", function () {
      api.rerender('783d4df2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/employeeCardPlaceholders/imgY.vue"
export default component.exports